export const BASE_URL = window.FZ_API_BASE_URL;

export async function updateMemberId(
  memberId?: string,
  accessToken?: string
): Promise<void> {
  if (!memberId) throw new Error('Нет memberId');
  if (!accessToken) throw new Error('Нет accessToken');

  const resp = await fetch(`${BASE_URL}/install/member/${encodeURIComponent(memberId)}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    }
  });

  if (!resp.ok) {
    const text = await resp.text();
    throw new Error(`Ошибка связывания memberId: ${resp.status} ${text}`);
  }
}
